import type { DataPointSample } from "@/lib/api/building";

// Shared current-value formatter (binary on/off → ON/OFF). Callers that already import
// from this module keep working; the implementation lives in `@/lib/format-signal-value`.
export { formatSignalValue } from "@/lib/format-signal-value";

// The zone sibling of equipment's Signaalit read (EquipmentView.tsx build_live_data_points_map):
// groups a single zone's own data_point_history samples by KB data_point name, chronological
// (oldest → newest). Both surfaces share this series — the tile/panel's current-value read takes
// the last entry, the detail route's history chart plots the whole array (#1451).
export function zoneSignalSeries(
  zoneId: string,
  samples: DataPointSample[],
): Record<string, DataPointSample[]> {
  const zone_samples = samples
    .filter((s) => s.source_type === "zone" && s.source_id === zoneId)
    .sort((a, b) => a.recorded_at.localeCompare(b.recorded_at));

  const series: Record<string, DataPointSample[]> = {};
  for (const sample of zone_samples) {
    (series[sample.name] ??= []).push(sample);
  }
  return series;
}
